require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/fn/regexp/escape.js
// module id = 591
// module chunks = 41